import { CooperationPartnerConfig } from '@app/icare/entities/cooperationPartner/config'
import { patientCooperationPartnerQueries } from '@app/icare/entities/cooperationPartner/queries/patientCooperationPartnerQueries'
import { PatientCooperationPartnerEditDrawer } from '@app/icare/entities/patient/edits/PatientCooperationPartnerEditDrawer'
import { patientFindingsQueryOptions } from '@app/icare/entities/patient/queries/patientFindingsQueryOptions'
import type { PatientCooperationPartnerRelation } from '@app/icare/entities/patient/schema/PatientCooperationPartner'
import { PatientId } from '@app/icare/entities/patient/schema/PatientId'
import { RelationTabs } from '@app/icare/routes/_app/patienten/$id/_edit/-components/RelationTabs'
import { isActivePatientRelation } from '@app/icare/shared/api'
import { t } from '@lingui/core/macro'
import { entityParams } from '@pkg/db/utils'
import { useQuery, useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { useRelationCommitNavigation } from '../-components/useRelationCommitNavigation'

export const Route = createFileRoute('/_app/patienten/$id/_edit/_cooperationPartner/kooperationspartner')({
  params: entityParams({ id: PatientId }),
  loader: ({ params, context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(patientCooperationPartnerQueries.forTabs(params.id)),
      queryClient.ensureQueryData(patientFindingsQueryOptions(params.id)),
    ]),
  component: RouteComponent,
})

function RouteComponent() {
  const { id } = Route.useParams()
  const { data: relations = [] } = useSuspenseQuery(patientCooperationPartnerQueries.forTabs(id))
  const { data: findings = [] } = useQuery(patientFindingsQueryOptions(id))
  const { data: totalCount } = useQuery(patientCooperationPartnerQueries.totalCount(id))
  const navigate = Route.useNavigate()

  const handleAfterCommit = useRelationCommitNavigation<PatientCooperationPartnerRelation>({
    isInactive: relation => !isActivePatientRelation(relation),
    onCreateNavigate: relation =>
      navigate({
        to: '/patienten/$id/kooperationspartner/$relation',
        params: { id, relation: relation.id },
      }),
    onInactiveEditNavigate: () => navigate({ to: '.', replace: true }),
  })
  return (
    <RelationTabs
      relations={relations}
      relationTotalCount={totalCount}
      basePath={`/patienten/${id}/kooperationspartner`}
      findings={findings}
      getLabel={item => CooperationPartnerConfig.format.primary(item.to) ?? t`Kooperationspartner`}
      onAdd={params =>
        void PatientCooperationPartnerEditDrawer.show({ patientId: id, onAfterCommit: handleAfterCommit, ...params })
      }
      entity="cooperationPartner"
    />
  )
}
